import PropTypes from 'prop-types'
import React from 'react'
import DonorsGroup from './components/DonorsGroup'
import OtherDonorsGroup from './components/OtherDonorsGroup'

function DonorsFilter({
  donors, values, setFieldValue, fieldName, fairPermissionTitle,
}) {
  const fairPermissionDonors = donors.filter((donor) => donor.hasFairPermission)
  const otherDonors = donors.filter((donor) => !donor.hasFairPermission)

  return (
    <>
      <DonorsGroup
        donors={fairPermissionDonors}
        values={values}
        setFieldValue={setFieldValue}
        fieldName={fieldName}
        title={fairPermissionTitle}
      />
      <OtherDonorsGroup
        donors={otherDonors}
        values={values}
        setFieldValue={setFieldValue}
        fieldName={fieldName}
      />
    </>
  )
}

DonorsFilter.propTypes = {
  donors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    photoURL: PropTypes.string,
    hasFairPermission: PropTypes.bool,
    donationsCount: PropTypes.number,
  })),
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string,
  fairPermissionTitle: PropTypes.string,
}

DonorsFilter.defaultProps = {
  donors: [],
  fieldName: 'excludedDonorIds',
  fairPermissionTitle: 'Pessoas com licença de feira',
}

export default DonorsFilter
